export enum License {
  BASIC_MONTHLY = 'workplan_basic_monthly',
  BASIC_YEARLY = 'workplan_basic_yearly',
  PRO_MONTHLY = 'workplan_pro_monthly',
  PRO_YEARLY = 'workplan_pro_yearly',
}
